import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import LifeSquares from '../components/LifeSquares';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export function StepLifeSquares({ lifeSquares, onLifeSquaresChange, userName, onNext, onBack }) {
  const handleChange = (field, value) => {
    const numValue = parseInt(value) || 0;
    const newData = { ...lifeSquares, [field]: numValue };
    
    // Calculate derived values
    newData.yearsLived = newData.currentAge || 0;
    newData.yearsRemaining = Math.max(0, (newData.targetAge || 100) - (newData.currentAge || 0));
    
    onLifeSquaresChange(newData);
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <Card>
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Cuadraditos de Vida</CardTitle>
          <CardDescription>
            Visualiza tu vida en cuadrados. Cada cuadrado representa un año.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="currentAge">Tu edad actual</Label>
              <Input
                id="currentAge"
                type="number"
                min="1"
                max="150"
                value={lifeSquares.currentAge || ''}
                onChange={(e) => handleChange('currentAge', e.target.value)}
                placeholder="35"
                data-testid="life-squares-current-age"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="targetAge">Edad objetivo (hasta cuántos años planeas vivir)</Label>
              <Input
                id="targetAge"
                type="number"
                min="1"
                max="150"
                value={lifeSquares.targetAge || ''}
                onChange={(e) => handleChange('targetAge', e.target.value)}
                placeholder="90"
                data-testid="life-squares-target-age"
              />
            </div>
          </div>
        </CardContent>
      </Card>

      {lifeSquares.currentAge > 0 && lifeSquares.targetAge > 0 && (
        <Card>
          <CardContent className="pt-6">
            <LifeSquares
              currentAge={lifeSquares.currentAge}
              targetAge={lifeSquares.targetAge}
              name={userName}
            />
          </CardContent>
        </Card>
      )}

      <div className="flex justify-between gap-4">
        <Button variant="outline" onClick={onBack} data-testid="wizard-back-button">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Atrás
        </Button>
        <Button 
          onClick={onNext} 
          className="flex-1"
          disabled={!lifeSquares.currentAge || !lifeSquares.targetAge}
          data-testid="wizard-next-button"
        >
          Siguiente
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}

export default StepLifeSquares;
